import React, { useEffect, useState } from 'react'
import ProductAdd from '../../../components/Modal/productAdd'
import ProductCard from './productCard'
import axios from 'axios'
import { products_uri } from '../../../utils/url'
import { Link } from 'react-router-dom'
import { Skeleton } from '@nextui-org/react'
import NotificationAdd from '../../../components/Modal/notificationAdd'
import Paginations from '../../../components/Pagination'

const Home = () => {
  const [data, setData] = useState([]);
  const [load, setLoad] = useState(false);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({limit:30, all:'', totalPage:'',name:''});

  const Get = async () => {
    setLoad(true);
    try{
      const res = await axios.get(products_uri + `/get?page=${page}&limit=${pagination.limit}&name=${pagination.name}`)
      setData(res.data.data);
      setPagination({...pagination, all:res.data.all, totalPage:res.data.totalPage});
      
      setLoad(false);
      
    }catch(err){
      console.log(err);
      setLoad(false);
    }
  }

  useEffect(() => {
    Get();
  }, [page]);
  
  const callback = () => {
    Get();
  }

  const changePage = (page) => {
    setPage(page);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      Get();
    }
  };

  return (
    <div className='bg-white rounded-md p-4'>
      <div className='flex justify-between items-center'>
        <h1>Барааны мэдээлэл</h1>
        <div className='flex items-center gap-2'>
          <NotificationAdd />
          <ProductAdd callback={callback}/>
          <Link to='/dashboard/create-order' className='bg-blue-600 rounded-md p-2 text-sm text-white'>Захиалга шивэх</Link>
        </div>
      </div>
      <div className='border-t mt-4'>
        <div className='mt-4'></div>
        <input onKeyDown={handleKeyDown} size='' className='border rounded-lg mt-2 mb-4 focus:border-1 focus:border-blue-600 outline-none w-full p-2 bg-gray-100' placeholder='Хайлт хийх' onChange={(e) => setPagination({...pagination, name:e.target.value})}/>
        <div className='grid grid-cols-5 gap-2'>
          {
            load?
            <>
              <Skeleton className='h-10 rounded-md'/>
              <Skeleton className='h-10 rounded-md'/>
              <Skeleton className='h-10 rounded-md'/>
              <Skeleton className='h-10 rounded-md'/>
            </>
            :
            <>
              {
              data.map((item, index) => {
                return(
                  <ProductCard key={index} data={item} callback={callback}/>
                )
              })
              }
              <Paginations initialPage={page} total={pagination.totalPage} alldata={pagination.all} onChange={changePage}/> 
            </>
          }
        </div>
      </div>
    </div>
  )
}




export default Home

